export default __webpack_public_path__ + "static/media/Classwin-aspect-ratio-four-to-three.92a9692c.svg";